module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_7016.e76d2e38.png";